import React from 'react';
import VoicePicker from '../VoicePicker';
import { COPY_STRINGS } from '../../constants/translatedCopy';
import take_a_test_bilingual from '../../images/voice_picker_icons/take_a_test_bilingual.svg';

/**
 * BTS bilingual assessment chooser.
 *
 * Shown only when a BTS-licensed HMH student has BOTH an English and a Spanish
 * assessment pending (see checkAssignments in App.js). Lets the student pick
 * which language to take; the chosen locale is reported via onChooseLanguage.
 *
 * Intentionally click-only (no TTS / voice matching): it renders during
 * assignment resolution, before the ready modal initializes audio/speech.
 * Reuses VoicePicker so the layout matches the existing ActivityPicker screen.
 */
export default class AssessmentLanguagePicker extends React.Component {
  constructor(props) {
    super(props);
    this.selectOption = this.selectOption.bind(this);

    this.title = COPY_STRINGS.great_to_see_you + ",";
    this.subTitle = COPY_STRINGS.what_activity_today;

    // Both cards always show both languages regardless of UI locale; locale only
    // drives the lang attribute (TTS pronunciation) and the chosen test language.
    this.options = [
      { name: COPY_STRINGS.take_a_test_english, locale: 'en-us', image: take_a_test_bilingual },
      { name: COPY_STRINGS.hacer_una_prueba_spanish, locale: 'es-mx', image: take_a_test_bilingual },
    ];
  }

  selectOption(option) {
    // Guard against a fast double-tap (common on kids' tablets) before the modal closes /
    // route advances, which would fire two launches + two history.push. Instance flag, not
    // state, so a second synchronous click is rejected even before any re-render.
    if (this.picked) return;
    this.picked = true;
    try {
      this.props.onChooseLanguage(option.locale);
    } catch (error) {
      // The handler launches + navigates synchronously; if it throws before completing,
      // the modal stays open. Release the guard so the student can retry instead of being
      // stranded on a dead chooser with no launch and no navigation.
      this.picked = false;
      console.error('[BTS] language selection failed; allowing retry', error);
    }
  }

  render() {
    return (
      <VoicePicker
        options={this.options}
        highlightedText={`${this.props.studentName}!`}
        title={this.title}
        subTitle={this.subTitle}
        selectOption={this.selectOption}
        buttonsDisabled={false}
      />
    );
  }
}
